import { RoleResources } from '..'

import employee from './employee'

export const sysop: RoleResources = {
  sysop_employee: employee,
}
